export const creators = [
  {
    id: 1,
    name: "Derek Haines",
    niche: "Business & Entrepreneurship",
    avatar: "https://public.readdy.ai/ai/img_res/9bee4a3e3dfda0669b2a4756820e564a.jpg",
    magazineTitle: "Venture",
    frequency: "Monthly",
    issues: 18,
    subscribers: "15.2K",
    quote: "Venture in print gave our brand a credibility that no newsletter or podcast ever could. Our readers actually keep every issue.",
    cover: "https://readdy.ai/api/search-image?query=bold%20business%20entrepreneurship%20magazine%20cover%20titled%20VENTURE%20with%20strong%20geometric%20black%20and%20white%20typography%2C%20confident%20entrepreneur%20silhouette%2C%20clean%20minimalist%20layout%2C%20deep%20black%20background%20with%20crisp%20white%20text%2C%20premium%20editorial%20print%20design%2C%20high%20contrast%20corporate%20aesthetic%2C%20bold%20red%20accent%20stripe%20detail&width=400&height=530&seq=802&orientation=portrait",
  },
  {
    id: 2,
    name: "Russell Greens",
    niche: "Gardening & Horticulture",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20portrait%20of%20middle%20aged%20man%20outdoors%20with%20warm%20natural%20lighting%2C%20sun%20dappled%20soft%20background%2C%20casual%20relaxed%20smile%2C%20editorial%20photography%2C%20cream%20background%2C%20high%20quality%20headshot&width=400&height=400&seq=103&orientation=squarish",
    magazineTitle: "Garden Guy",
    frequency: "Quarterly",
    issues: 10,
    subscribers: "7.3K",
    quote: "Readers tell me they flip through Garden Guy while actually in the garden. It's the highest compliment I've ever received.",
    cover: "https://readdy.ai/api/search-image?query=charming%20gardening%20magazine%20cover%20titled%20GARDEN%20GUY%20with%20lush%20green%20botanical%20photography%2C%20vibrant%20fresh%20vegetables%20and%20herbs%20in%20foreground%2C%20clean%20cream%20white%20background%2C%20elegant%20hand-lettered%20serif%20title%20typography%20in%20deep%20forest%20green%2C%20premium%20editorial%20print%20design%2C%20warm%20natural%20light%2C%20rustic%20organic%20magazine%20layout%2C%20editorial%20quality&width=400&height=530&seq=104&orientation=portrait",
  },
  {
    id: 3,
    name: "Elara Windmere",
    niche: "Fantasy & Tolkien Universe",
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20young%20woman%20with%20ethereal%20expression%2C%20soft%20dramatic%20studio%20lighting%2C%20dark%20moody%20neutral%20background%2C%20fantasy%20editorial%20photography%20style%2C%20sharp%20focus%2C%20high%20quality&width=400&height=400&seq=105&orientation=squarish",
    magazineTitle: "Girl of Gondor",
    frequency: "Monthly",
    issues: 30,
    subscribers: "28.7K",
    quote: "Every issue is a love letter to Tolkien's world. My readers treat it like a collector's artifact — because it is.",
    cover: "https://readdy.ai/api/search-image?query=epic%20fantasy%20magazine%20cover%20titled%20GIRL%20OF%20GONDOR%20inspired%20by%20Tolkien%20Lord%20of%20the%20Rings%2C%20dramatic%20moonlit%20stone%20fortress%20architecture%20towers%20against%20deep%20midnight%20black%20sky%2C%20sweeping%20cinematic%20landscape%20with%20silver%20stars%20and%20glowing%20moon%2C%20elegant%20elvish%20serif%20typography%20in%20cream%20and%20silver%20on%20deep%20black%20background%2C%20premium%20epic%20editorial%20print%20design%2C%20painterly%20illustration%20quality&width=400&height=530&seq=106&orientation=portrait",
  },
  {
    id: 4,
    name: "Maggie Collier",
    niche: "Junk Journaling & Mixed Media",
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20creative%20young%20woman%20with%20warm%20smile%2C%20bright%20studio%20lighting%2C%20crafts%20and%20paper%20ephemera%20in%20soft%20background%20blur%2C%20artistic%20headshot%2C%20high%20quality%20photography&width=400&height=400&seq=107&orientation=squarish",
    magazineTitle: "Scrappy",
    frequency: "Monthly",
    issues: 22,
    subscribers: "19.1K",
    quote: "My readers have a waiting list for every issue. Scrappy in print is — ironically — the most polished thing I've ever made.",
    cover: "https://readdy.ai/api/search-image?query=eclectic%20junk%20journaling%20magazine%20cover%20titled%20SCRAPPY%20with%20vintage%20paper%20ephemera%20collage%20layered%20textures%2C%20aged%20cream%20and%20ivory%20paper%20scraps%2C%20postage%20stamps%2C%20handwritten%20script%20accents%2C%20washi%20tape%20strips%2C%20red%20ribbon%20detail%2C%20distressed%20retro%20editorial%20magazine%20design%2C%20artistic%20mixed%20media%20aesthetic%2C%20charming%20whimsical%20layout%2C%20warm%20cream%20black%20and%20red%20palette%2C%20premium%20print%20quality&width=400&height=530&seq=108&orientation=portrait",
  },
  {
    id: 5,
    name: "Priya Nair",
    niche: "Fashion & Identity",
    avatar: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20south%20asian%20woman%20with%20confident%20expression%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20professional%20headshot%20photography%2C%20sharp%20focus%20high%20quality&width=400&height=400&seq=109&orientation=squarish",
    magazineTitle: "Drape",
    frequency: "Quarterly",
    issues: 8,
    subscribers: "6.2K",
    quote: "The printing process elevates my visual storytelling in ways the digital medium simply cannot.",
    cover: "https://readdy.ai/api/search-image?query=high%20fashion%20identity%20magazine%20cover%20with%20dramatic%20portrait%20photography%2C%20bold%20minimalist%20typography%2C%20black%20and%20cream%20color%20palette%2C%20editorial%20fashion%20magazine%20design%2C%20premium%20luxury%20print&width=400&height=530&seq=110&orientation=portrait",
  },
  {
    id: 6,
    name: "Elias Thorne",
    niche: "Technology & Society",
    avatar: "https://readdy.ai/api/search-image?query=professional%20editorial%20portrait%20of%20young%20man%20thoughtful%20expression%2C%20soft%20natural%20lighting%2C%20neutral%20grey%20background%2C%20business%20casual%20attire%2C%20high%20quality%20headshot%20photography&width=400&height=400&seq=111&orientation=squarish",
    magazineTitle: "Signal",
    frequency: "Monthly",
    issues: 18,
    subscribers: "9.1K",
    quote: "In a world of scrolling, my readers actually sit down and read. Print commands a different kind of attention.",
    cover: "https://readdy.ai/api/search-image?query=technology%20society%20magazine%20cover%20with%20abstract%20digital%20art%2C%20cool%20neutral%20tones%20with%20subtle%20warm%20accent%2C%20clean%20geometric%20typography%2C%20premium%20editorial%20magazine%20design%2C%20sophisticated%20minimalist%20print&width=400&height=530&seq=112&orientation=portrait",
  },
];

export const distributionPlans = [
  {
    id: 1,
    frequency: "Weekly",
    icon: "ri-calendar-todo-line",

    description: "Perfect for high-volume content creators with a consistently engaged audience.",
    features: [
      "Up to 52 issues per year",
      "16–32 pages per issue",
      "Priority production queue",
      "Dedicated account manager",
      "Real-time distribution tracking",
    ],
    highlight: false,
  },
  {
    id: 2,
    frequency: "Monthly",
    icon: "ri-calendar-2-line",

    description: "Our most popular plan. Ideal for established creators with regular monthly content.",
    features: [
      "12 issues per year",
      "32–64 pages per issue",
      "Premium paper stock options",
      "Custom cover design",
      "Subscriber management portal",
    ],
    highlight: true,
  },
  {
    id: 3,
    frequency: "Quarterly",
    icon: "ri-calendar-event-line",

    description: "Great for creators who produce deep, seasonal content with a dedicated readership.",
    features: [
      "4 issues per year",
      "48–96 pages per issue",
      "Hardcover options available",
      "Full editorial design support",
      "Newstand & retail distribution",
    ],
    highlight: false,
  },
];

export const teamMembers = [
  {
    id: 1,
    name: "Charlotte Blake",
    role: "Founder & Editor-in-Chief",
    bio: "Former creative director at Condé Nast with 15 years of editorial experience across print and digital media.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20editorial%20portrait%20of%20confident%20middle%20aged%20woman%20executive%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20elegant%20attire%2C%20editorial%20photography%20style%20high%20quality&width=400&height=400&seq=201&orientation=squarish",
  },
  {
    id: 2,
    name: "David Lark",
    role: "Head of Production",
    bio: "20 years in luxury print production. Has overseen the printing of over 5 million magazines across four continents.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20editorial%20portrait%20of%20confident%20middle%20aged%20man%2C%20soft%20warm%20lighting%2C%20neutral%20background%2C%20smart%20attire%2C%20editorial%20photography%20style%2C%20high%20quality%20headshot&width=400&height=400&seq=202&orientation=squarish",
  },
  {
    id: 3,
    name: "Nadia Bloom",
    role: "Creative Director",
    bio: "Award-winning graphic designer whose work has appeared in The New Yorker, Monocle, and National Geographic.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20editorial%20portrait%20of%20young%20creative%20woman%20with%20artistic%20flair%2C%20warm%20studio%20lighting%2C%20light%20neutral%20background%2C%20professional%20creative%20headshot%2C%20high%20quality%20editorial%20photography&width=400&height=400&seq=203&orientation=squarish",
  },
  {
    id: 4,
    name: "Omar Castellano",
    role: "Creator Relations",
    bio: "Built creator programs at Substack and Medium before joining. He's helped over 200 creators launch their own publications.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20editorial%20portrait%20of%20young%20hispanic%20man%20warm%20smile%2C%20natural%20studio%20lighting%2C%20neutral%20background%2C%20business%20casual%20attire%2C%20high%20quality%20headshot%20photography&width=400&height=400&seq=204&orientation=squarish",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Submit Your Content",
    description: "Upload your articles, images, and creative assets through our creator portal. We accept everything from written pieces to photography and illustration.",
    icon: "ri-upload-cloud-2-line",
  },
  {
    step: "02",
    title: "Editorial & Design",
    description: "Our in-house editorial and design team transforms your raw content into a beautifully laid-out magazine. Every spread is crafted with intention.",
    icon: "ri-palette-line",
  },
  {
    step: "03",
    title: "Premium Production",
    description: "We print on archival-grade paper using state-of-the-art presses. Every detail — binding, finish, and color — is held to the highest standard.",
    icon: "ri-printer-line",
  },
  {
    step: "04",
    title: "Global Distribution",
    description: "Your magazine reaches subscribers worldwide through our logistics network. Weekly, monthly, or quarterly — on schedule, every time.",
    icon: "ri-global-line",
  },
];
